import React, { useEffect, useState } from "react";
import { MdDirectionsBus } from "react-icons/md";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../../context/Auth";
import { RotatingLines } from "react-loader-spinner";

const EditInvoice = () => {
    const {invoice_id} = useParams();
    const [invoice, setInvoice] = useState({})
    const [updateData, setUpdateData] = useState({})
    const [loading, setLoading] = useState(false);
    const [updatingInvoice, setUpdatingInvoice] = useState(false);
    const {requestWithAuth} = useAuth()

    const handleChange = (e) => {
        setUpdateData({ ...updateData, [e.target.name]: e.target.value });
      };
    
      const updateSupplierInvoice = async (e) => {
        e.preventDefault();
        setUpdatingInvoice(true);
        const body =JSON.stringify(updateData)
        try {
          const response = await requestWithAuth(`/supplier/invoice/${invoice_id}/details/`, "PUT", body, {
            "Content-Type": "application/json",
            
          });
          setUpdatingInvoice(false);
          toast.success("Invoice details updated successfully");
        } catch (error) {
          toast.error("Failed to update supplier invoice. Please try again later.");
          console.error(error);
          setUpdatingInvoice(false);
        }
      };

    const getSupplierInvoice = async () => {
        setLoading(true);
        
        try {
          const response = await requestWithAuth(`/supplier/invoice/${invoice_id}/details/`, "GET");
          setLoading(false);
          setInvoice(response)
          
        } catch (error) {
          toast.error("Failed to get invoice details. Please try again later.");
          console.error(error);
          setLoading(false);
        }
      };

      useEffect(()=>{
        getSupplierInvoice()
      },[])
  return (
    <div className="p-[20px]">
      <div className="w-[60%] mx-auto">
        <form onSubmit={(e)=>updateSupplierInvoice(e)} className="">
          <div className="mb-[20px] border border-[#ddd] rounded-[3px] bg-white">
            <div className="p-[20px]">
              <h5 className="my-[2px] text-[17px]">
                Supplier Invoice{" "}
              </h5>
            </div>
            <div className="p-[20px] pt-0">
              <div className="flex items-center gap-2 mb-[20px] pb-[10px] uppercase border-b border-[#e5e5e5]">
                <MdDirectionsBus className="text-[12px]" />
                <label htmlFor="item" className="text-[12px] font-[500]">
                  Sales details
                </label>
              </div>
              <div className="grid grid-cols-2 gap-3">
                
                <div className="flex flex-col mb-[20px]">
                  <label htmlFor="" className="font-bold">
                    Invoice Date:
                  </label>
                  <input
                    type="date"
                    name="invoice_date"
                    onChange={(e) => {
                        handleChange(e);
                      }}
                    value={updateData?.invoice_date ? updateData?.invoice_date : invoice?.invoice_date}
                    id=""
                    className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                  />
                </div>
                <div className="flex flex-col mb-[20px]">
                  <label htmlFor="" className="font-bold">
                    Invoice Narration:
                  </label>
                  <select  onChange={(e) => {
                      handleChange(e);
                    }} name="invoice_narration" id="" className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]">
                    <option value="Supply" selected = {invoice?.invoice_narration === "Supply"}>Supply</option>
                    <option value="Credit Note" selected = {invoice?.invoice_narration === "Credit Note"}>Credit Note</option>
                  </select>
                  
                </div>
                
                <div className="flex flex-col mb-[20px]">
                  <label htmlFor="" className="font-bold">
                    Invoice Amount:
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    name="invoice_amount"
                    value={updateData?.invoice_amount ? updateData?.invoice_amount : invoice?.invoice_amount}
                    id=""
                    onChange={(e) => {
                        handleChange(e);
                      }}
                    className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                  />
                </div>

                <div className="flex flex-col mb-[20px]">
                  <label htmlFor="" className="font-bold">
                    Invoice Number:
                  </label>
                  <input
                    type="text"
                    name="invoice_number"
                    onChange={(e) => {
                        handleChange(e);
                      }}
                    value={updateData?.invoice_number ? updateData?.invoice_number : invoice?.invoice_number}
                    id=""
                    className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                  />
                </div>
              </div>
              <div className="flex justify-end">
                {!updatingInvoice ? (
                  <button className="bg-[#2196F3] px-[12px] py-[7px] text-[13px] rounded-[3px] mt-5 text-white">
                    Submit Form
                  </button>
                ) : (
                  <div className="bg-[#2195f3bb] cursor-wait px-[12px] py-[7px] text-[13px] rounded-[3px] mt-5 text-white flex items-center gap-2">
                    <RotatingLines
                      type="Grid"
                      color="#fff"
                      width="15"
                      height="15"
                    />{" "}
                    Submitting
                  </div>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditInvoice;
